import {Badge} from "antd";
import {Link} from "react-router-dom";
import {DownCircleOutlined, RetweetOutlined, CloseCircleOutlined} from '@ant-design/icons';

import {ReactComponent as DelegateIcon} from "./icons/delegate.svg";
import {ReactComponent as ClientIcon} from "./icons/client.svg";

import {createSort} from "../../shared/utilities/sortFunctions";

import styles from "./mission-table.module.scss"

const missionStatus = {
    0: "Selecting a candidate",
    1: "Client Posted mission",
    2: "Mission Accepted by Delegate",
    3: "Mission declined by Delegate",
    4: "Mission started",
    5: "In progress",
    6: "Delegate completed mission",
    7: "Client confirms mission completed successfully",
    8: "Client confirms mission is not completed",
};

const missionCategories = {
    0: "Factory visit",
    1: "Factory visit",
    2: "Site visit",
    3: "Store check",
    4: "Other",
}

const statusColor = {
    "no-delegate": "#6E7BFF",
    started: "#F580EA",
    archived: "#B6BED4",
}

export const columns = [
    {
        title: 'Clients',
        dataIndex: 'clients',
        key: "clients",
        sorter: (a, b) => {
            if(!a.users.client || !b.users.client) {
                return 0;
            }

            const aName = `${a.users.client?.last_name}, ${a.users.client?.first_name}`;
            const bName = `${b.users.client?.last_name}, ${b.users.client?.first_name}`;

            return aName.localeCompare(bName)
        },
        render: (_, {users}) => (
            <p className={styles.user}>
                <ClientIcon /> {users.client && <span> {`${users.client?.last_name}, ${users.client?.first_name}`}</span>}
            </p>)
    },
    {
        title: 'Delegates',
        dataIndex: 'delegates',
        key: "delegates",
        responsive: ['lg'],
        sorter: (a, b) => {

            if(!a.users.delegate && b.users.delegate) {
                return -1;
            } else if(a.users.delegate && !b.users.delegate) {
                return 1;
            }

            const aName = `${a.users.delegate?.last_name}, ${a.users.delegate?.first_name}`;
            const bName = `${b.users.delegate?.last_name}, ${b.users.delegate?.first_name}`;

            return aName.localeCompare(bName)
        },
        render: (_, {users}) => (
            <p className={styles.user}>
                <DelegateIcon /> {users.delegate && <span>{`${users.delegate?.last_name}, ${users.delegate?.first_name}`}</span>} <br />
            </p>)
    },
    {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        responsive: ['md'],
        filters: [
            {
                text: 'Selecting a candidate',
                value: 0,
            },
            {
                text: 'Client Posted mission',
                value: 1,
            },
            {
                text: 'Mission Accepted by Delegate',
                value: 2,
            },
            {
                text: 'Mission declined by Delegate',
                value: 3,
            },
            {
                text: 'Mission started',
                value: 4,
            },
            {
                text: 'In progress',
                value: 5,
            },
            {
                text: 'Delegate completed mission',
                value: 6,
            },
            {
                text: 'Client confirms mission completed successfully',
                value: 7,
            },
            {
                text: 'Client confirms mission is not completed',
                value: 8,
            },
        ],
        onFilter: (value, record) => record.status === value,
        sorter: (a, b) => a.status - b.status,
        render: (_, {status}) => <span>{missionStatus[status]}</span>,
    },
    {
        title: 'Date',
        dataIndex: 'date',
        key: "date",
        responsive: ['md'],
        sorter: (a, b) => a.date - b.date,
    },
    {
        title: 'Mission Type',
        dataIndex: 'category',
        key: 'category',
        responsive: ['lg'],
        filters: [
            {
                text: "Factory visit",
                value: 0,
            },
            {
                text: "Factory visit",
                value: 1,
            },
            {
                text: "Site visit",
                value: 2,
            },
            {
                text: "Store check",
                value: 3,
            },
            {
                text: "Other",
                value: 4,
            },
        ],
        onFilter: (value, record) => record.category === value,
        sorter: (a, b) => a.category - b.category,
        render: (category) => <span>{missionCategories[category]}</span>
    },
    {
        title: 'Amount',
        dataIndex: 'amount',
        key: 'amount',
        responsive: ['md'],
        sorter: (a, b) => a.amount - b.amount,
        render: (amount) => <span>{`$ ${amount}`}</span>,
    },
    {
        title: '',
        dataIndex: 'details',
        key: "details",
    },
];
